var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_435_10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7727 10.5L14.7363 13.4637C14.9063 13.6336 15 13.8598 15 14.1C15 14.3402 14.9063 14.5664 14.7363 14.7363C14.5664 14.9063 14.3402 15 14.1 15C13.8598 15 13.6336 14.9063 13.4637 14.7363L10.5 11.7727L7.53633 14.7363C7.3664 14.9063 7.14024 15 6.9 15C6.65976 15 6.4336 14.9063 6.26367 14.7363C6.09374 14.5664 6 14.3402 6 14.1C6 13.8598 6.09374 13.6336 6.26367 13.4637L9.22734 10.5L6.26367 7.53633C6.09374 7.36642 6 7.14024 6 6.9C6 6.65976 6.09374 6.4336 6.26367 6.26367C6.43388 6.09374 6.65976 6 6.9 6C7.14024 6 7.36612 6.09374 7.53633 6.26367L10.5 9.22734L13.4637 6.26367C13.6339 6.09374 13.8598 6 14.1 6C14.3402 6 14.5661 6.09374 14.7363 6.26367C14.9063 6.43358 15 6.65976 15 6.9C15 7.14024 14.9063 7.3664 14.7363 7.53633L11.7727 10.5Z",
    fill: "#BB393D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.75,
    stroke: "#CC5A5A",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_435_10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "matrix(1 0 0 -1 6 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.fc85b2a44adabafd4bf6e1aedc420faa.svg";
export { ForwardRef as ReactComponent };